/* unplugin-vue-components disabled */import { render } from "./share-modal.vue?vue&type=template&id=9ccfc2ec&scoped=true"
import script from "./share-modal.vue?vue&type=script&lang=js"
export * from "./share-modal.vue?vue&type=script&lang=js"

import "./share-modal.vue?vue&type=style&index=0&id=9ccfc2ec&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ccfc2ec"],['__file',"src/pages/chats/chat-sharing-v2/share-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9ccfc2ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9ccfc2ec', __exports__)) {
    api.reload('9ccfc2ec', __exports__)
  }
  
  module.hot.accept("./share-modal.vue?vue&type=template&id=9ccfc2ec&scoped=true", () => {
    api.rerender('9ccfc2ec', render)
  })

}


export default __exports__